module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1b_Image13f.4880d5ff.jpg";